import styled from "styled-components";
import HeroBg from "../../assets/EqipmentHeroBg.jpg";

const EquipmentHero = () => {
  return (
    <TheEquipmentHero>
      <div className="heroBG">
        <img src={HeroBg} alt="Equipment Hero" />
      </div>
      <div className="hero-overlay" />
      <div className="hero-content">
        <span className="hero-label">AgroHarvest Machineries — Catalog</span>
        <h1>
          Explore our
          <br />
          Equipment
        </h1>
        <p>
          High-quality agricultural machinery designed to boost your
          productivity and efficiency.
        </p>
      </div>
      <div className="hero-rule" />
    </TheEquipmentHero>
  );
};

const TheEquipmentHero = styled.div`
  width: 100%;
  height: 55vh;
  position: relative;
  overflow: hidden;
  font-family: "Georgia", "Times New Roman", serif;

  .heroBG {
    position: absolute;
    inset: 0;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.78) 0%,
      rgba(0, 0, 0, 0.45) 100%
    );
    z-index: 2;
  }

  .hero-content {
    position: absolute;
    bottom: 3.5rem;
    left: 6rem;
    z-index: 3;
    max-width: 620px;

    .hero-label {
      display: block;
      font-family: "Courier New", monospace;
      font-size: 0.72rem;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      color: rgba(255, 255, 255, 0.5);
      margin-bottom: 1.2rem;
    }

    h1 {
      font-size: clamp(2.4rem, 5vw, 4.5rem);
      font-weight: 400;
      color: #f5f2ed;
      line-height: 1;
      letter-spacing: -0.02em;
      margin: 0 0 1.2rem;
    }

    p {
      font-size: 1rem;
      color: rgba(255, 255, 255, 0.6);
      line-height: 1.7;
      font-style: italic;
      margin: 0;
      max-width: 420px;
    }
  }

  .hero-rule {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.12);
    z-index: 3;
  }

  @media screen and (max-width: 1024px) {
    .hero-content {
      left: 3rem;
    }
  }

  @media screen and (max-width: 768px) {
    height: 48vh;
    .hero-content {
      left: 2rem;
      bottom: 2.5rem;
    }
  }

  @media screen and (max-width: 600px) {
    height: 42vh;
    .hero-content {
      left: 1.5rem;
      bottom: 2rem;
      max-width: 90%;
      h1 {
        font-size: 2rem;
      }
      p {
        font-size: 0.88rem;
      }
    }
  }

  @media screen and (max-width: 420px) {
    height: 40vh;
    .hero-content {
      h1 {
        font-size: 1.6rem;
      }
      p {
        font-size: 0.8rem;
      }
    }
  }

  @media screen and (max-width: 350px) {
    height: 38vh;
    .hero-content {
      h1 {
        font-size: 1.35rem;
      }
    }
  }
`;

export default EquipmentHero;
